module.exports = __webpack_public_path__ + "img/ساده-.0f431368.jpg";